export enum NotificationTypeEnum {
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'information',
  WARNING = 'warning',
}
